import {useState, useLayoutEffect } from 'react';

interface ResizeConfig {
    width: number;
    height: number;
}

export const useResizeTable = (selector: string) => {
    const [resizeConfig, setResizeConfig] = useState({
       width: 0,
       height: 0
    } as ResizeConfig);

    const updateResizeConfig = (container: any) => {
        const width = container.clientWidth;
        const height = container.clientHeight;

        setResizeConfig({ width, height });
    };

    useLayoutEffect(() => {
        const resize = () => {
            const container = document.querySelector(`div.${selector}`);
            if(container) {
                updateResizeConfig(container);
            }
        };

        const container = document.querySelector(`div.${selector}`);
        if(container) {
            if(container.clientHeight > 0 && container.clientWidth > 0) {
                updateResizeConfig(container);
                window.addEventListener('resize', resize);
            }
        }

        return () => {
            window.removeEventListener('resize', resize);
        };
    }, []);

    return resizeConfig;
};

export default useResizeTable;